"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _SpeakerList = _interopRequireDefault(require("./SpeakerList"));
var _ActionArea = _interopRequireDefault(require("./ActionArea"));
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    wrapper: (0, _defineProperty2.default)({
      display: 'flex',
      flexDirection: 'column',
      '& p': {
        margin: theme.spacing(0)
      }
    }, theme.breakpoints.up('md'), {
      flexDirection: 'row',
      padding: theme.spacing(5, 0, 0.5, 0)
    }),
    webinarContent: (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), {
      marginRight: theme.spacing(16),
      maxWidth: '620px',
      width: '100%'
    }),
    category: {
      fontSize: theme.typography.pxToRem(12),
      fontWeight: theme.typography.fontWeightBold,
      '&$category': {
        marginBottom: theme.typography.pxToRem(4)
      }
    },
    title: {
      fontSize: theme.typography.pxToRem(20),
      lineHeight: theme.typography.pxToRem(24),
      fontWeight: theme.typography.fontWeightBold,
      textTransform: 'uppercase',
      '&$title': (0, _defineProperty2.default)({
        marginBottom: theme.typography.pxToRem(4)
      }, theme.breakpoints.up('md'), {
        marginBottom: theme.typography.pxToRem(14)
      }),
      letterSpacing: theme.typography.pxToRem(1.17)
    }
  };
});
var WebinarContent = function WebinarContent(props) {
  var _props$category = props.category,
    category = _props$category === void 0 ? [] : _props$category,
    title = props.title,
    summary = props.summary,
    speakers = props.speakers,
    url = props.url,
    sessions = props.sessions,
    duration = props.duration,
    language = props.language,
    learnMoreCta = props.learnMoreCta,
    sessionText = props.sessionText,
    presentedText = props.presentedText,
    durationText = props.durationText,
    languageText = props.languageText,
    defaultSpeakerImage = props.defaultSpeakerImage,
    primaryCategory = props.primaryCategory,
    primarySubCategory = props.primarySubCategory,
    type = props.type;
  var classes = useStyles();
  var categoryList = (primaryCategory || primarySubCategory ? [primaryCategory, primarySubCategory] : category).join(', ');
  var actionAreaProps = {
    duration: duration,
    durationText: durationText,
    language: language,
    languageText: languageText,
    sessions: sessions,
    sessionText: sessionText,
    presentedText: presentedText,
    url: url,
    learnMoreCta: learnMoreCta,
    type: type
  };
  return __jsx("div", {
    className: classes.wrapper
  }, __jsx("div", {
    className: classes.webinarContent
  }, category && category.length > 0 && __jsx(_core.Typography, {
    className: classes.category,
    dangerouslySetInnerHTML: {
      __html: categoryList
    }
  }), title && __jsx(_core.Typography, {
    className: classes.title,
    dangerouslySetInnerHTML: {
      __html: title
    }
  }), summary && __jsx(_core.Typography, {
    dangerouslySetInnerHTML: {
      __html: summary
    }
  }), speakers && speakers.length > 0 && __jsx(_SpeakerList.default, {
    speakers: speakers,
    defaultSpeakerImage: defaultSpeakerImage
  })), __jsx(_ActionArea.default, actionAreaProps));
};
var _default = WebinarContent;
exports.default = _default;